import getDateFromString from "@/helpers/getDateFromString";

export default function getTime(dateInString) {
    const {hours, minutes} = getDateFromString(dateInString);
    return `${hours}:${minutes}`;
}